module.exports = __webpack_public_path__ + "static/media/auth_bottom.0562f4be.svg";